import { useEffect, useState } from "react";
import { fetchCandidateData } from "../services/api";

const initialState = { data: null, loading: false, error: null };

export const useCandidateData = () => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState({ data: null, loading: true, error: null });

    fetchCandidateData()
      .then((data) =>
        setState({
          data,
          loading: false,
          error: null,
        })
      )
      .catch((error) => {
        console.error(error);
        setState({
          data: null,
          loading: false,
          error: "Error fetching Candidates data 😔 Please refresh.",
        });
      });
  }, []);

  return state;
};
